// extracted by mini-css-extract-plugin
export var container = "_2u-0";
export var error = "_2u-9";
export var label = "_2u-5";
export var light = "_2u-6";
export var md = "_2u-3";
export var sm = "_2u-2";
export var thin = "_2u-8";
export var thinBold = "_2u-7";
export var vertical = "_2u-4";
export var xs = "_2u-1";